/* eslint-disable */

import Modal from "components/Modal";
import { Form, Select, Input, Button } from "antd";
import { useTranslation } from "react-i18next";

const ConfirmationModal = ({
  handleComment,
  workName,
  id,
  workComment,
  visible,
  closeModal,
  type,
  method,
}) => {
  const { t } = useTranslation();
  const { TextArea } = Input;
  const tailLayout = {
    wrapperCol: { offset: 10, span: 16 },
  };
  const onFinish = (values) => {
    values.id = id;
    values.type = type;
    values.method = method;
    handleComment(values);
    closeModal();
  };

  return (
    <Modal
      open={visible}
      onCancel={() => {
        closeModal();
      }}
      titleText={`${workName}`}
      footer={null}
      width="600px"
      maskStyle={{ background: "rgba(0, 0, 0, 0.2)" }}
      destroyOnClose
    >
      <div className="alarm-modal">
        <Form
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
        >
          <Form.Item name="comment" label={t("comment")}>
            <TextArea
              defaultValue={workComment}
              disabled
              autoSize
              label={t("comment")}
              rows={3}
              cols={10}
              maxLength={100}
            />
          </Form.Item>
          <Form.Item style={{ width: "180px" }}>
            <Select disabled defaultValue={workName} />
          </Form.Item>
          <Form.Item
            name="commentFinal"
            label={t("comment")}
            rules={[{ required: true, message: t("missingComment") }]}
          >
            <TextArea
              autoSize
              label={t("comment")}
              rows={3}
              cols={10}
              maxLength={100}
            />
          </Form.Item>
          <Form.Item {...tailLayout}>
            <Button type="primary" htmlType="submit">
              {t("apply")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
